import type { ExperienceState } from "@/types/state";

type WatermarkProps = {
  experienceState: ExperienceState;
  title?: string;
};

export default function Watermark({ experienceState, title }: WatermarkProps) {
  const metadata = experienceState.experienceData.metadata;
  const url = metadata.getSharedAssetUrl("common/pixmoto-logo-horiz-white.svg");

  return (
    <div className="watermark">
      <img src={url} alt="Pixmoto" />
      <span>{title}</span>
    </div>
  );
}
